




import { Component, Vue } from "vue-property-decorator";
import Calendar from "@/components/Calendar.vue"; // @ is an alias to /src

@Component({
  components: {
    Calendar
  }
})
export default class CalendarPage extends Vue {}
